import { ContactFormData } from '@/modules/kontakt/components/ContactForm'

/**
 * Ergebnis ohne Fehlertext fuer die Oberflaeche: statusText bzw. die
 * Browsermeldung ("Load failed", "Failed to fetch") landete frueher 1:1 im
 * Toast. Die Komponente zeigt stattdessen eine uebersetzte Meldung, der
 * Status dient nur der Fehlersuche.
 */
export type SendContactMailResult = { success: true; data: unknown } | { success: false; error: { status: number | null } }

export async function sendContactMail(data: ContactFormData): Promise<SendContactMailResult> {
  try {
    const response = await fetch('/api/send-mail', {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    })

    if (!response.ok) {
      return { success: false, error: { status: response.status } }
    }
    const responseData = await response.json()
    return { success: true, data: responseData }
  } catch {
    return { success: false, error: { status: null } }
  }
}
